module.exports = __webpack_public_path__ + "img/system_4_1.9c6c9e27.png";